"use strict";
// https://ballysports.atlassian.net/wiki/spaces/EN/pages/63864881/Link
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = exports.LinkParam = void 0;
var uritemplate_1 = __importDefault(require("uritemplate"));
var zod_1 = require("zod");
exports.LinkParam = zod_1.z.object({
    id: zod_1.z.string(),
    type: zod_1.z.enum(['header', 'path']),
    name: zod_1.z.string(),
    required: zod_1.z.boolean()
});
exports.Link = zod_1.z.object({
    url: zod_1.z
        .string()
        .url()
        .refine(function (url) {
        try {
            uritemplate_1.default.parse(url);
            return true;
        }
        catch (ex) {
            return false;
        }
    }, { message: 'Invalid URI Template', path: ['url'] })
        .describe('A url that conforms to RFC 6570'),
    params: zod_1.z
        .array(exports.LinkParam)
        .optional()
        .describe('Params to be pulled from the session response (or other where applicable)')
});
